import styled from "styled-components";

export const MessageBoxContainer = styled.div<{
  messageType: "success" | "error" | "warning" | null;
}>`
  z-index: 999;
  left: 50%;
  transform: translateX(-50%);
  width: 30%;
  /* fixed, não absolute, de propósito.
   *
   * O MessageBox nasceu só nas telas de login e cadastro, onde o pai era a
   * página inteira. Dentro da área privada o pai é o ContentWrapper, que tem
   * overflow: auto — com absolute a mensagem rolava junto com o conteúdo e
   * podia nascer fora da janela; em tela longa como a Configuração, ninguém
   * veria o recado. fixed prende no topo da janela, que é onde um aviso de
   * "salvou" ou "não salvou" precisa estar. */
  position: fixed;
  top: calc(var(--u) * 90);
  background-color: ${(props) =>
    props.messageType === "success"
      ? "#44cb13ba"
      : props.messageType === "error"
      ? "#fc000096"
      : props.messageType === "warning"
      ? // O ramo que faltava. A Configuração já emitia "warning" (recusa de
        // salvamento, "nada mudou", tela pulada) e caía no transparent: texto
        // branco em fundo transparente = aviso invisível.
        "#e0930096"
      : "transparent"};
  color: white;
  padding: var(--sp-10);
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--sp-10);
  font-size: var(--fs-md);
  line-height: 1.4;
  box-shadow: 0 calc(var(--u) * 2) calc(var(--u) * 8) rgba(0, 0, 0, 0.18);
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: white;
  cursor: pointer;
  font-size: var(--fs-base);
`;
